<template>
  <v-row>
    <v-col>
      <v-row class="px-2 pt-2">
        <v-col>
          <general-error v-if="!!generalError && !editUserDialog.show" />
          <v-expansion-panels>
            <v-expansion-panel v-test="{ panel: '' }">
              <v-expansion-panel-header>
                <div id="search">
                  <v-icon>
                    search
                  </v-icon>
                  {{ $t('Фильтры') }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager @keydown.native.enter="focusOnBtn('searchBtn')">
                <v-row class="px-3">
                  <v-col
                      cols="12"
                      sm="9"
                      md="5"
                      lg="3">
                    <v-text-field
                        v-model="params.organizationName"
                        v-test="{ input: 'organizationName' }"
                        clearable
                        :label="$t('Наименование организации')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      cols="12"
                      sm="9"
                      md="5"
                      lg="3">
                    <v-text-field
                        v-model="params.userName"
                        v-test="{ input: 'userName' }"
                        clearable
                        :label="$t('Имя пользователя')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      cols="12"
                      sm="9"
                      md="5"
                      lg="3">
                    <v-text-field
                        v-model="params.contactPerson"
                        v-test="{ input: 'contactPerson' }"
                        clearable
                        :label="$t('Контактное лицо')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      cols="12"
                      sm="9"
                      md="5"
                      lg="3">
                    <v-text-field
                        v-model="params.inn"
                        v-test="{ input: 'inn' }"
                        clearable
                        :label="$t('ИНН')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      cols="12"
                      sm="9"
                      md="5"
                      lg="3">
                    <v-text-field
                        v-model="params.ogrn"
                        v-test="{ input: 'ogrn' }"
                        clearable
                        :label="$t('ОГРН/КИО')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      class="text-right pr-2"
                      align-self="center">
                    <btn-icon-tip
                        id="search"
                        ref="searchBtn"
                        icon="search"
                        icon-color="primary"
                        :tip="$t('Поиск')"
                        @click="search" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <paginated-data-table
              v-if="getUsersList"
              ref="paginatedTable"
              :headers="headers1"
              :items="users"
              :loading="isLoading"
              item-key="userId"
              :total-count="totalCount"
              :items-per-page="itemsPerPage"
              single-expand
              show-expand
              :request-method="getUsersList">
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.contactPerson="{ item }">
              <route-link-with-tip
                  :id="`${item.userName}-${item.userId}`"
                  :text="`${item.userName} ${item.contactPerson ? '(' + item.contactPerson + ')' : ''}`"
                  :tip="$t('Просмотр пользователя')"
                  :to="{ path: `${urlRootPath}/user/${item.userId}` }" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.organizationShortName="{ item }">
              <route-link-with-tip
                  :text="item.organizationShortName"
                  :tip="$t('Просмотр организации')"
                  :to="{ path: `${urlRootPath}/organization/${item.organizationId}` }" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.inn="{ item }">
              {{ item.inn }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.lastLoginDate="{ item }">
              {{ item.lastLoginDate
                ? $moment(item.lastLoginDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.lastActivityDate="{ item }">
              {{ item.lastActivityDate
                ? $moment(item.lastActivityDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.validTo="{ item }">
              {{ item.validTo
                ? $moment(item.validTo).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.participantType="{ item }">
              {{ $t(PARTICIPANT_TYPE_ENUM[item.participantType]) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.email="{ item }">
              {{ item.email }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.isLocked="{ item }">
              <btn-icon-tip
                  v-if="isAdmin || isOrganizer"
                  :id="`lock-${item.userId}`"
                  :icon="item.isLocked
                    ? 'lock'
                    : 'lock_open'"
                  :icon-color="item.isLocked
                    ? 'error'
                    : 'success'"
                  :tip="$t('Изменить статус. Текущий: {0}', [ $t(item.isLocked
                    ? 'Заблокирован'
                    : 'Активный') ] )"
                  @click="openLockStatusDialog(item.userId, item.isLocked)" />
              <icon-tip
                  v-else
                  :icon="item.isLocked
                    ? 'lock'
                    : 'lock_open'"
                  :icon-color="item.isLocked
                    ? 'error'
                    : 'success'"
                  :tip="$t(item.isLocked
                    ? 'Заблокирован'
                    : 'Активный')" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.subscriptionsStatus="{ item }">
              <btn-icon-tip
                  v-if="isAdmin || isOrganizer"
                  :id="`subscriptions-${item.userId}`"
                  :icon="item.subscriptionsIcon"
                  :icon-color="item.subscriptionsColor"
                  :tip="$t('Изменить подписки')"
                  @click="openSubscriptionsDialog(item.userId)" />
              <icon-tip
                  v-else
                  :icon="item.subscriptionsIcon"
                  :icon-color="item.subscriptionsColor"
                  :tip="$t(item.subscriptionsStatus
                    ? SUBSCRIPTIONS_TYPE_ENUM[item.subscriptionsStatus]
                    : null)" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row class="text-left my-1">
                  <date-view
                      :display="item.lastLoginDate"
                      :label="$t('Дата последнего входа в систему')"
                      date-format="DD.MM.YYYY HH:mm" />
                </v-row>
                <v-divider v-if="isAdmin || isOrganizer" />
                <v-row v-if="isAdmin || isOrganizer" class="text-left my-1">
                  <btn-icon-tip
                      v-if="!!item.participantType"
                      :id="`editUser-${item.userId}`"
                      :icon="'edit'"
                      :tip="$t('Редактировать данные пользователя')"
                      @click="openEditUserDialog(item.userId)" />
                  <btn-icon-tip
                      v-if="!item.participantType"
                      :id="`editEmail-${item.userId}`"
                      :icon="'edit'"
                      :tip="$t('Редактировать Email')"
                      @click="openEditUserEmailDialog(item.userId)" />
                  <btn-icon-tip
                      v-if="!item.emailConfirmed"
                      :id="`forward_to_inbox_${item.userId}`"
                      :key="`forward_to_inbox_${item.userId}`"
                      :disabled="isLoading"
                      icon="mdi-email-send-outline"
                      :tip="$t('Повторно отправить письмо для подтверждения почтового адреса')"
                      @click="resetConfirmEmail(item.userId)" />
                </v-row>
              </td>
            </template>
          </paginated-data-table>
        </v-col>
      </v-row>
      <confirm-dialog
          v-if="confirmDialog.show"
          :dialog-prop="confirmDialog"
          @close="closeDialog('confirmDialog')" />
      <edit-user-dialog
          v-if="editUserDialog.show"
          :dialog-prop="editUserDialog"
          @close="closeDialog('editUserDialog')" />
      <edit-user-email-dialog
          v-if="editUserEmailDialog.show"
          :dialog-prop="editUserEmailDialog"
          @close="closeDialog('editUserEmailDialog')" />
      <subscriptions-dialog
          v-if="subscriptionsDialog.show"
          :subscriptions="subscriptions"
          :dialog-prop="subscriptionsDialog"
          @close="closeDialog('subscriptionsDialog')" />
    </v-col>
  </v-row>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import SubscriptionsDialog from '@/components/reused/common/SubscriptionsDialog.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import EditUserDialog from './EditUserDialog.vue'
  import EditUserEmailDialog from './EditUserEmailDialog.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { PARTICIPANT_TYPE_ENUM, SUBSCRIPTIONS_TYPE_ENUM } from '@/constants/enums'
  import { USER_TYPES, SUBSCRIPTION_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      IconTip,
      DateView,
      EditUserDialog,
      EditUserEmailDialog,
      RouteLinkWithTip,
      ConfirmDialog,
      GeneralError,
      PaginatedDataTable,
      SubscriptionsDialog
    },
    props: {
      status: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        PARTICIPANT_TYPE_ENUM,
        SUBSCRIPTIONS_TYPE_ENUM,
        itemsPerPage: 10,
        isLoading: false,
        subscriptionsDialog: {
          show: false,
          userId: null,
          callback: null
        },
        confirmDialog: {
          show: false,
          additional: null,
          text: null,
          callback: null,
          warning: true
        },
        editUserDialog: {
          show: false,
          userId: null,
          callback: null
        },
        editUserEmailDialog: {
          show: false,
          userId: null,
          callback: null
        },
        params: {
          organizationName: '',
          isRegistered: true,
          userName: '',
          contactPerson: '',
          inn: '',
          ogrn: ''
        }
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        usersInfo: state => userStatus => (state[USER_MANAGEMENT.STATE.USERS][userStatus] || {}),
        subscriptions: state => (state[USER_MANAGEMENT.STATE.SUBSCRIPTIONS] || {})
      }),
      headers1 () {
        let headers = [
          { text: this.$t('Пользователь'), align: 'start', sortable: true, value: 'contactPerson' },
          { text: this.$t('Организация'), align: 'start', sortable: true, value: 'organizationShortName' },
          { text: this.$t('ИНН'), align: 'start', sortable: true, value: 'inn' },
          { text: this.$t('Время последнего входа'), align: 'start', sortable: true, value: 'lastLoginDate' },
          { text: this.$t('Время последней активности'), align: 'start', sortable: true, value: 'lastActivityDate' },
          { text: this.$t('Доступ разрешен до'), align: 'start', sortable: false, value: 'validTo' },
          { text: this.$t('Категория участия'), align: 'start', sortable: true, value: 'participantType' },
          { text: this.$t('Статус блокировки'), align: 'start', sortable: false, value: 'isLocked' },
          { text: this.$t('Подписка на рассылку'), align: 'start', sortable: false, value: 'subscriptionsStatus' },
          { text: '', value: 'data-table-expand' }
        ]
        if (!this.params.isRegistered) {
          headers = headers.filter(h =>
            h.value !== 'inn' &&
            h.value !== 'participantType' &&
            h.value !== 'organizationShortName' &&
            h.value !== 'subscriptionsStatus')
        }

        return headers
      },
      totalCount () {
        return this.usersInfo(this.userStatus).totalCount || 0
      },
      users () {
        const users = this.usersInfo(this.userStatus).items || []
        return users.map(u => {
          let subscriptionsColor, subscriptionsIcon
          switch (u.subscriptionsStatus) {
          case SUBSCRIPTION_TYPES.FULL:
            subscriptionsColor = 'success'
            subscriptionsIcon = 'email'
            break
          case SUBSCRIPTION_TYPES.PARTIAL:
            subscriptionsColor = 'warning'
            subscriptionsIcon = 'email'
            break
          case SUBSCRIPTION_TYPES.NONE:
            subscriptionsColor = 'error'
            subscriptionsIcon = 'unsubscribe'
            break
          default:
            subscriptionsColor = 'error'
            subscriptionsIcon = 'unsubscribe'
          }
          return {
            ...u,
            subscriptionsIcon,
            subscriptionsColor
          }
        })
      },
      userStatus () {
        return this.params.isRegistered
          ? USER_TYPES.REGISTERED
          : USER_TYPES.UNREGISTERED
      }
    },
    watch: {
      status: {
        immediate: true,
        handler (newValue) {
          this.params.isRegistered = newValue === USER_TYPES.REGISTERED
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getUsersListAction: USER_MANAGEMENT.ACTIONS.GET_USERS_LIST,
        changeUserLockStatusAction: USER_MANAGEMENT.ACTIONS.CHANGE_USER_LOCK_STATUS,
        resetConfirmEmailAction: USER_MANAGEMENT.ACTIONS.RESET_CONFIRM_EMAIL,
        getUserSubscriptionAction: USER_MANAGEMENT.ACTIONS.GET_USER_SUBSCRIPTION,
        changeUserSubscriptionAction: USER_MANAGEMENT.ACTIONS.CHANGE_USER_SUBSCRIPTION,
        clearUsersListAction: USER_MANAGEMENT.ACTIONS.CLEAR_USERS_LIST,
        clearUserSubscriptionAction: USER_MANAGEMENT.ACTIONS.CLEAR_USER_SUBSCRIPTION
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUsersListAction(this.userStatus),
            this.clearUserSubscriptionAction()
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getUsersList: async function (params) {
        try {
          this.isLoading = true
          await this.getUsersListAction({
            ...params,
            ...this.params
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getUserSubscription: async function (userId) {
        this.isLoading = true
        try {
          await this.getUserSubscriptionAction({ userId })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      openSubscriptionsDialog: async function (userId) {
        this.subscriptionsDialog.userId = userId
        try {
          await this.clearUserSubscriptionAction()
          await this.getUserSubscription(userId)
        } catch (error) {
          this.throwIfNotServerError(error)
        }

        this.subscriptionsDialog.callback = this.changeUserSubscription
        this.subscriptionsDialog.show = true
      },
      openEditUserDialog: function (userId) {
        this.editUserDialog.userId = userId
        this.editUserDialog.callback = this.$refs.paginatedTable.getDataFromServer
        this.editUserDialog.show = true
      },
      openEditUserEmailDialog: function (userId) {
        this.editUserEmailDialog.userId = userId
        this.editUserEmailDialog.callback = this.$refs.paginatedTable.getDataFromServer
        this.editUserEmailDialog.show = true
      },
      openLockStatusDialog: function (userId, isLocked) {
        this.confirmDialog.additional = {
          isLocked: !isLocked,
          userId
        }
        this.confirmDialog.text = this.$t('Пользователь будет {0}. Продолжить?',
                                          [isLocked
                                            ? this.$t('разблокирован')
                                            : this.$t('заблокирован')])
        this.confirmDialog.callback = this.changeUserLockStatus
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      changeUserSubscription: async function (subscriptions) {
        this.isLoading = true
        try {
          await this.changeUserSubscriptionAction({
            userId: this.subscriptionsDialog.userId,
            subscriptions
          })
          this.$refs.paginatedTable.getDataFromServer()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      changeUserLockStatus: async function (status) {
        this.isLoading = true
        try {
          await this.changeUserLockStatusAction(status)
          this.isLoading = false
          this.$refs.paginatedTable.getDataFromServer()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      resetConfirmEmail: async function (userId) {
        this.isLoading = true
        try {
          await this.resetConfirmEmailAction({
            userId
          })
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
